<script>
    import FilterAddHeader from '@/components/page-filter-edit/filter-add/FilterAddHeader.vue';
    import FilterAddData from '@/components/page-filter-edit/filter-add/FilterAddData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_FILTER_ADD}
        },
        components: {
            FilterAddHeader: FilterAddHeader,
            FilterAddData: FilterAddData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <FilterAddHeader />
        <hr class="hr_light_98">
        <FilterAddData />
    </div>
</template>